import { z } from "zod"

import type { Keys, Equals, AssertEqual } from "./type-fu"

/**
 * ExperimentId
 */

export const experimentIds = ["powerSteering", "multiFileApplyDiff", "preventFocusDisruption", "autocomplete"] as const

export const experimentIdsSchema = z.enum(experimentIds)

export type ExperimentId = z.infer<typeof experimentIdsSchema>

/**
 * Experiments
 */

export const experimentsSchema = z.object({
	powerSteering: z.boolean().optional(),
	multiFileApplyDiff: z.boolean().optional(),
	preventFocusDisruption: z.boolean().optional(),
	autocomplete: z.boolean().optional(),
})

export type Experiments = z.infer<typeof experimentsSchema>

type _AssertExperiments = AssertEqual<Equals<ExperimentId, Keys<Experiments>>>
